<script setup>
import { computed } from 'vue';
import ContactInfoRow from './ContactInfoRow.vue';

const props = defineProps({
  contact: {
    type: Object,
    default: () => ({}),
  },
  conversationAttributes: {
    type: Object,
    default: () => ({}),
  },
});

const contactAttributes = computed(
  () => props.contact.additional_attributes || {}
);

const platformName = computed(() => {
  const { platform_name: name, platform_version: version } =
    props.conversationAttributes.browser || {};
  return [name, version].filter(Boolean).join(' ');
});

const visitorIp = computed(
  () =>
    contactAttributes.value.visitor_ip || contactAttributes.value.created_at_ip
);

const visitorLocation = computed(() => {
  const city =
    contactAttributes.value.visitor_city || contactAttributes.value.city;
  const country =
    contactAttributes.value.visitor_country || contactAttributes.value.country;
  return (
    [city, country].filter(Boolean).join(', ') || props.contact.location || ''
  );
});
</script>

<template>
  <div class="w-full rounded-md bg-n-blue-3 px-2 py-1.5">
    <ContactInfoRow
      :value="platformName"
      icon="globe-desktop"
      emoji="💻"
      :title="$t('CONTACT_PANEL.OS')"
      :aria-label="$t('CONTACT_PANEL.OS')"
      class="font-medium [&>div]:text-n-blue-11"
    />
  </div>
  <div class="w-full rounded-md bg-n-iris-3 px-2 py-1.5">
    <ContactInfoRow
      :value="visitorIp"
      icon="globe"
      emoji="🌐"
      :title="$t('CONTACT_PANEL.IP_ADDRESS')"
      :aria-label="$t('CONTACT_PANEL.IP_ADDRESS')"
      class="font-medium [&>div]:text-n-iris-11"
    />
  </div>
  <div class="w-full rounded-md bg-n-teal-3 px-2 py-1.5">
    <ContactInfoRow
      :value="visitorLocation"
      icon="map"
      emoji="🌍"
      :title="$t('CONTACT_PANEL.LOCATION')"
      :aria-label="$t('CONTACT_PANEL.LOCATION')"
      class="font-medium [&>div]:text-n-teal-11"
    />
  </div>
</template>
